import { useEffect } from "react";
import { createBrowserHistory } from "history";
import { useNavigate } from "react-router-dom";

const history = createBrowserHistory();

const DisableBackButton = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const unblock = history.block((location, action) => {
      navigate("/");
      return true;
    });

    return () => {
      unblock()
    };
  }, []);
  return <></>;
};

export default DisableBackButton;
